import React from 'react'
import Footer from '../../components/Footer';
import EducationImg from "../../assets/images/diplomao.jpeg";
import { Link } from 'react-router-dom';
import Title from '../../components/TitleComponent';

const Education = () => {
  return (
    <div className='w-full relative font-poppins'>
        <Title canonicalPath="/programmes/School-Of-Education" />
        <Title title="Best Education College in Dehradun, Uttarakhand" description=" Maya Devi University is one of the best Engineering University in Dehradun, offering world-class Education programs in different Branches." />
        <div className='w-10/12 mx-auto mt-[100px] md:mt-[150px] flex flex-col gap-5 md:gap-5'>
            <h2 className={`mb-4 text-2xl md:text-6xl tracking-tight font-bold text-center text-[#0e4d38]`}>
                School of Education
            </h2>
            <div className='w-[20%] mx-auto h-[6px] bg-[#23376c] mt-[-10px] md:mt-[-20px]'></div>
            
            <div className='flex flex-col md:flex-row gap-8 mb-10 md:gap-[80px] mt-5 justify-center md:justify-between'>
                <img src={EducationImg} className='md:w-[40%] rounded-lg' alt="Education at Maya Devi University"/>
                <div className='flex flex-col gap-4'>
                    <h4 className='font-bold text-xl md:text-3xl'>About the Department</h4>
                    <p className='text-justify md:text-lg'>
                        The School of Education at Maya Devi University is committed to shaping the future of education by nurturing competent and passionate educators. Our Bachelor of Education (B.Ed.) program is designed to equip aspiring teachers with the knowledge, skills, and values needed to inspire and educate the next generation. Rooted in academic excellence and practical learning, the program focuses on holistic teacher training, combining theoretical understanding with hands-on experience.
                        <br/><br/>
                        <strong>Course Highlights:</strong><br/>
                        <ul className='list-disc text-[14px]'>
                            <li>Comprehensive curriculum covering educational psychology, pedagogy, and subject-specific teaching methodologies</li>
                            <li>Emphasis on developing modern teaching techniques and technology integration</li>
                            <li>Extensive practical training through classroom observations, internships, and micro-teaching sessions</li>
                            <li>Personality development and communication skills enhancement</li>
                        </ul>
                        <br/>
                        <strong>Benefits of B.Ed. Program:</strong><br/>
                        <ul className='list-disc text-[14px]'>
                            <li>Professional Growth through in-depth knowledge and skills</li>
                            <li>Practical exposure in real classroom environments</li>
                            <li>Advanced teaching techniques and classroom management strategies</li>
                            <li>Access to expert faculty and state-of-the-art infrastructure</li>
                            <li>Strong foundation for diverse education sector roles</li>
                        </ul>
                    </p>
                    <Link to="https://admission.maya.edu.in/">
                        <button className='mt-5 md:mt-0 bg-[#23376c] px-4 py-2 text-white rounded-full font-semibold transition-all duration-200 hover:bg-[#4865b3]'>
                            Register Now
                        </button>
                    </Link>
                </div>
            </div>

            <div className='flex flex-col gap-10 mt-5 mb-[50px]'>
                <div className='flex flex-col gap-2'>
                    <h4 className={`text-2xl font-semibold text-[#0e4d38]`}>Career Opportunities</h4>
                    <p>A B.Ed. degree from Maya Devi University opens up numerous career opportunities:</p>
                    <ul className='list-disc ml-5 mt-2'>
                        <li>School Teacher in primary, secondary, or senior secondary schools</li>
                        <li>Educational Administrator in school management</li>
                        <li>Content Developer for educational publishers</li>
                        <li>Educational Counselor</li>
                        <li>Corporate Trainer</li>
                        <li>Educational Researcher</li>
                    </ul>
                </div>
            </div>

            {/* Course Details Table */}
            <div className="flex flex-col">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <table className="min-w-full text-center text-sm font-light">
                                <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
                                    <tr>
                                        <th scope="col" className="px-6 py-4">Programme</th>
                                        <th scope="col" className="px-6 py-4">Duration (Years)</th>
                                        <th scope="col" className="px-6 py-4">No. of Seats</th>
                                        {/* <th scope="col" className="px-6 py-4">One time Charges including Registration</th>
                                        <th scope="col" className="px-6 py-4">Yearly Fee (All India Quota)</th>
                                        <th scope="col" className="px-6 py-4">Yearly Fee (UK Domicile)</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b dark:border-neutral-500">
                                        <td className="whitespace-nowrap px-6 py-4 font-semibold">Bachelor of Education (B.Ed.)</td>
                                        <td className="whitespace-nowrap px-6 py-4">2</td>
                                        <td className="whitespace-nowrap px-6 py-4">50</td>
                                        {/* <td className="whitespace-nowrap px-6 py-4">Rs.21000/-</td>
                                        <td className="whitespace-nowrap px-6 py-4">Rs.85000/-</td>
                                        <td className="whitespace-nowrap px-6 py-4">Rs.65000/-</td> */}
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hostel Fee Table */}
            {/* <div className="flex flex-col mt-10 mb-10">
                <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
                    <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
                        <div className="overflow-hidden">
                            <table className="min-w-full text-center text-sm font-light">
                                <thead className="border-b bg-[#23376c] font-medium text-white rounded-md">
                                    <tr>
                                        <th></th>
                                        <th scope="col" className="px-6 py-4">Hostel Fee</th>
                                        <th></th>
                                    </tr>
                                    <tr>
                                        <th scope="col" className="px-6 py-4">Sr. No</th>
                                        <th scope="col" className="px-6 py-4">Type</th>
                                        <th scope="col" className="px-6 py-4">Fee</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr className="border-b dark:border-neutral-500">
                                        <td className="whitespace-nowrap px-6 py-4">1</td>
                                        <td className="whitespace-nowrap px-6 py-4">Triple Sharing (Non AC)</td>
                                        <td className="whitespace-nowrap px-6 py-4">75000/-</td>
                                    </tr>
                                    <tr className="border-b dark:border-neutral-500">
                                        <td className="whitespace-nowrap px-6 py-4">2</td>
                                        <td className="whitespace-nowrap px-6 py-4">Double Sharing (Non AC)</td>
                                        <td className="whitespace-nowrap px-6 py-4">85000/-</td>
                                    </tr>
                                    <tr className="border-b dark:border-neutral-500">
                                        <td className="whitespace-nowrap px-6 py-4">3</td>
                                        <td className="whitespace-nowrap px-6 py-4">Triple Sharing (AC)</td>
                                        <td className="whitespace-nowrap px-6 py-4">115000/-</td>
                                    </tr>
                                    <tr className="border-b dark:border-neutral-500">
                                        <td className="whitespace-nowrap px-6 py-4">4</td>
                                        <td className="whitespace-nowrap px-6 py-4">Double Sharing (AC)</td>
                                        <td className="whitespace-nowrap px-6 py-4">125000/-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
        <Footer/>
    </div>
  )
}

export default Education